module.exports = __webpack_public_path__ + "5196b1c61b662a28eff99e704d9529e7.png";